module.exports = __webpack_public_path__ + "img/sortImg1-2.33c812e5.png";